import { Statistic } from "../../molecules/Statistic"
import { trpc } from "../../trpc"
import { isDefined } from "../../utils/is-defined"
import { AnalyticsQueryArgs } from "./Analytics"
import { KeyframeDeltaGraph } from "./graphs/KeyframeDelta"
import { PacketArrivalTimeAvgGraph } from "./graphs/PacketArrivalTimeAverage"
import { PacketArrivalTimeMaxGraph } from "./graphs/PacketArrivalTimeMax"

const Restarts = (props: AnalyticsQueryArgs) => {
  const { data: restarts } = trpc.analytics.restartCount.useQuery({ ...props }, { keepPreviousData: true })

  return (
    <div className="my-4 mb-12 flex flex-col gap-4 xl:flex-row">
      <div className="flex gap-4 xl:w-1/2">
        <div className="w-1/2 transition-colors">
          <Statistic
            value={isDefined(restarts) ? restarts : "-"}
            title="Restarts"
            subtext="Times ingest started"
            info="Total times ingest has started over the selected time period. This includes controlled restarts."
          />
        </div>
      </div>
    </div>
  )
}

export const Stability = (props: AnalyticsQueryArgs): JSX.Element => {
  return (
    <>
      <Restarts {...props} />
      <KeyframeDeltaGraph {...props} />
      <PacketArrivalTimeAvgGraph {...props} />
      <PacketArrivalTimeMaxGraph {...props} />
    </>
  )
}
